'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function LinkList({ links, routes }) {
  if (!Array.isArray(links) || !links.length) {
    return null;
  }

  return h(
    '.row-contrast',
    h(
      '.page-container',
      h(
        '.row',
        h(
          '.twelve.columns',
          h(
            '.links',
            {
              'data-bhw': 'PopularStores',
            },
            [
              h('h3', h(Translate, 'modules.shared.PopularStores')),
              h(
                'ul',
                links.map(link =>
                  h(
                    'li',
                    h(
                      'a',
                      {
                        href: routes.merchant.show.replace(
                          '{merchantSlug}',
                          link.merchantSlug
                        ),
                        'data-bhc': `store:${link.merchantSlug}`,
                      },
                      link.merchantName
                    )
                  )
                )
              ),
            ]
          )
        )
      )
    )
  );
}

module.exports = LinkList;
